/**
 * @internal
 */
export const COMPONENT_NAME = 'ChipGroup';
